import { FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";

type AppLinkProps = LinkProps & MuiLinkProps;
const AppLink: FC<AppLinkProps> = props => {
  const { children, ...otherProps } = props;

  return (
    <MuiLink component={Link} underline="none" {...otherProps}>
      {children}
    </MuiLink>
  );
};

export default AppLink;
